import { render, staticRenderFns } from "./versionmgmt.vue?vue&type=template&id=cf8c4438&scoped=true&"
import script from "./versionmgmt.vue?vue&type=script&lang=js&"
export * from "./versionmgmt.vue?vue&type=script&lang=js&"
import style0 from "./versionmgmt.vue?vue&type=style&index=0&id=cf8c4438&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf8c4438",
  null
  
)

export default component.exports